const STORAGE_KEY = "chartDateRange";

export const readStoredChartRange = () => {
    const stored = sessionStorage.getItem(STORAGE_KEY);
    if (!stored) return null;
    const range = JSON.parse(stored);
    const startDate = new Date(range?.startDate).getTime();
    const endDate = new Date(range?.endDate).getTime();
    if (isNaN(startDate) || isNaN(endDate)) return null;
    return { ...range, startDate, endDate };
};

export const storeChartRange = (range) => {
    if (!range) return;
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(range));
};